// extracted by mini-css-extract-plugin
export default {"btn":"btn-F0qbN5","content":"content-DiFjId","title":"title-WFDYnd"};